import { Component } from '@angular/core';

@Component({
  selector: 'xos-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent {}
